@import '../../utils/global.module.less';

.deleteButton {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-right: 12px;
    padding: 6px 12px;
    background-color: transparent;
    border: none;
    border-radius: 8px;
    font-family: 'Hanken Grotesk';
    font-size: 14px;
    font-weight: 500;
    color: #3b4a68;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    &:hover {
        background-color: #eef1f6;
    }
    &:active {
        background-color: #e3e6eb;
    }
}

.deleteIcon {
    width: 16px;
    height: 16px;
}

.modalTitle {
    font-family: 'LustTextMedium';
    font-weight: normal;
}

